import styled from 'styled-components'

export const TitleOnButtonResponsive = styled.p`
  font-size: 13px;

  @media (max-width: 1536px) {
    display: none;
  }
`

export const ContainerHeaderLpr = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 1748px) {
    column-gap: 20px;
  }
  @media (max-width: 1558px) {
    column-gap: 10px;
  }
  @media (max-width: 1050px) {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
`

export const BoxResponsive = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 16px;

  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
`
